const {combineReducers} = require("redux");

/**
 * Home Reducer
 */
module.exports = combineReducers({
  profileForm: require("./profile"),
  memberForm: require("./member"),
  validateForm: require("./validate"),
  guestForm: require("./guest"),
  invitationForm: require("./invitation"),
  userForm: require("./user"),
  appForm: require("./app"),
  serviceForm: require("./service"),
  apiForm: require("./api"),
  themeForm: require("./theme"),
  groupForm: require("./group"),
  projectForm: require("./project"),
  licenceForm: require("./licence"),
  roleForm: require("./role"),
  licenceAndRole: require("./licenceAndRole"),
  users: require("./users")
});
